var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_DocumentEntry"),
                    name: "seDocInput"
                  }
                },
                [
                  _c("se-input-detail", {
                    attrs: {
                      "tab-name": "seDocInput",
                      "tab-title": _vm.$t("CargoMsg.Cargo_DocumentEntry")
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_QueryTags"),
                    name: "searchMark"
                  }
                },
                [
                  _c("search-mark-detail", {
                    attrs: {
                      "tab-name": "searchMark",
                      "tab-title": _vm.$t("CargoMsg.Cargo_QueryTags")
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ChargebackManage"),
                    name: "managementOfWithdrawal"
                  }
                },
                [
                  _c("management-of-withdrawal-detail", {
                    attrs: {
                      "tab-name": "managementOfWithdrawal",
                      "tab-title": _vm.$t("CargoMsg.Cargo_ChargebackManage")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }